import React, { useEffect, useState } from "react";
import "./CourseInfo.css";
import { Link } from "react-router-dom";
import { IMAGE_URL } from "../../config/config";
import { useCart } from "../../context/CartContext";
import { useProducts } from "../../context/ProductContext";
import { toast } from "react-toastify";

const CourseInfo = ({ course: initialCourse }) => {

  console.log("hu", initialCourse);
  
  const { addToCart } = useCart();
  const { getCourseByName } = useProducts();
  
  const [course, setCourse] = useState(initialCourse.data || null);
  const [loading, setLoading] = useState(!initialCourse);

  useEffect(() => {
    if (!course && initialCourse?.product_name) {
      const loadCourse = async () => {
        try {
          setLoading(true);
          const data = await getCourseByName(
            initialCourse.product_name
          );
          if (data) setCourse(data);
        } catch (err) {
          console.error("Course fetch by name failed", err);
        } finally {
          setLoading(false);
        }
      };

      loadCourse();
    }
  }, [course, initialCourse, getCourseByName]);

  if (loading) {
    return (
      <div className="text-center py-5">
        <h5>Loading course details...</h5>
      </div>
    );
  }

  if (!course) {
    return (
      <div className="text-center py-5 text-danger">
        Course not found.
      </div>
    );
  }

  const parsedPrice = (() => {
    try {
      const parsed = JSON.parse(course.price);
      return parsed?.[0]?.price || "0";
    } catch {
      return "0";
    }
  })();


  const handleAddToCart = async () => {
    const result = await addToCart({
      product_id: course.product_id,
      product_name: course.product_name,
      price: parsedPrice,
      image: course.image,
      category_name: course.category_name,
    });

    if (result?.status === "added") {
      toast.success(
        <div>
          <p className="mb-2 fw-bold">Product added to cart</p>
        </div>,
        {
          position: "bottom-right",
          autoClose: 2000,
        }
      );
    }
  };

  const courseImage = course.image
    ? `${IMAGE_URL}/uploads/${encodeURIComponent(course.image)}`
    : "/placeholder-course.png";

  return (
    <div className="container my-5">
      <div className="row g-4">
        <div className="col-lg-8">
          <div className="shadow-sm p-4 rounded-4 bg-white">
            <img
              src={courseImage}
              alt={course.product_name}
              className="img-fluid rounded-4 mb-3"
            />

            <span className="badge bg-gradient px-3 py-2 mb-3">
              {course.category_name || "Course"}
            </span>

            <div className="d-flex align-items-center justify-content-between flex-wrap">
              <h2 className="fw-bold mb-2 text-dark">
                {course.product_name}
              </h2>

              {course.rating > 0 && (
                <div className="rating-stars mb-2">
                  {Array.from({ length: 5 }, (_, i) => (
                    <i
                      key={i}
                      className={`fa-star ${
                        i + 1 <= course.rating
                          ? "fas text-warning"
                          : "far text-secondary"
                      }`}
                    ></i>
                  ))}
                  <span className="ms-2 text-muted">
                    {course.rating} / 5
                  </span>
                </div>
              )}
            </div>

            <p className="text-secondary">
              {course.description || "No description available."}
            </p>

            {course.learnings?.length > 0 && (
              <>
                <h4 className="mt-4 text-dark">What You’ll Learn</h4>
                <ul className="list-unstyled theme-list">
                  {course.learnings.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}

            {course.requirements?.length > 0 && (
              <>
                <h4 className="mt-4 text-dark">Requirements</h4>
                <ul className="list-unstyled theme-list">
                  {course.requirements.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </>
            )}
          </div>
        </div>

        <div className="col-lg-4">
          <div className="card shadow-sm border-0 rounded-4 p-3 mb-4">
            <img
              src={courseImage}
              className="img-fluid rounded-4 mb-3"
              alt={course.product_name}
            />
            <h3 className="text-primary fw-bold">₹ {parsedPrice}</h3>

            <button
              className="btn btn-theme w-100 py-2 mb-3"
              onClick={handleAddToCart}
            >
              Add to Cart
            </button>

            <hr />

            <h6 className="fw-bold">Course Includes:</h6>
            <ul className="list-unstyled">
              <li>
                <i className="fa fa-video me-2 text-primary"></i>
                {course.lessons || "10"}
              </li>
              <li>
                <i className="fa fa-user me-2 text-primary"></i>
                {course.instructor || "Expert Instructor"}
              </li>
            </ul>
          </div>

          <div className="card shadow-sm border-0 rounded-4 p-3">
            <h5 className="fw-bold">More Courses</h5>
            <Link to="/courses" className="text-primary text-decoration-none">
              View All →
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseInfo;
